/**
 * FokusFilterOption - Individual filter checkbox option
 */

import React from 'react';
import { CheckIcon } from '../../filterUtils';

const FokusFilterOption = ({ 
  label, 
  color, 
  checked, 
  onChange, 
  isTag = false 
}) => (
  <label className="fokus-button__option">
    <span className="fokus-button__option-check">
      {checked && <CheckIcon />}
    </span>
    <span 
      className={`fokus-button__option-color ${isTag ? 'fokus-button__option-color--tag' : ''}`} 
      style={{ backgroundColor: color }} 
    />
    <span className="fokus-button__option-label">{label}</span>
    <input 
      type="checkbox" 
      checked={checked} 
      onChange={onChange} 
      className="fokus-button__option-input" 
    />
  </label>
);

export default FokusFilterOption;
